<template>
  <vs-popup title="Ajouter un client" :active.sync="isPromptActiveLocal">
    <vs-row>
      <vs-select
        placeholder="Selectionnez un chargé"
        autocomplete
        class="w-full"
        label="Chargé d'affaire"
        v-model="form.charger"
      >
        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in charger" />
      </vs-select>
    </vs-row>
    <vs-button color="primary" class="mt-2" type="filled" @click="assignation()">Ajouter</vs-button>
    <vs-button color="primary" class="mt-2 ml-2" type="border" @click="close()">Annuler</vs-button>
  </vs-popup>
</template>

<script>
    export default {
        name: "charger",
        props: {
          isPromptActive: {
            type: Boolean,
            required: true
          },
          charger: {
            type: Array
          },
          refreshContent: {
            type: Function
          }
        },
        watch: {
          isPromptActive(val) {
            if (!val) return;
          }
        },
        computed: {
          isPromptActiveLocal: {
            get() {
              return this.isPromptActive
            },
            set(val) {
              if (!val) {
                this.form.charger = ''
                this.$emit('closePrompt')
              }
            }
          },
        },
        data: () => ({
          form: {
            charger: ''
          }
        }),
        methods: {
          close(){
            this.form.charger = ''
            this.$emit('closePrompt')
          },
          assignation(){
            if (this.form.charger !== ''){
              this.$vs.loading()
              this.$http.post('/problems/assign', {
                id: this.$route.params.id,
                user_id: this.form.charger
              }).then((response) => {
                this.$vs.loading.close()
                if (response.data.status){
                  this.close()
                  this.refreshContent()
                  window.GETCCMT.success('Le problème a été assigné', {});
                }else {
                  window.GETCCMT.error({ message: 'Une erreur est survenue lors de l\'opération.' });
                }
              }).catch((error) =>{
                console.log(error)
                this.$vs.loading.close()
              })
            }else {
              window.GETCCMT.error({ message: 'Veuillez selectionner une charge d\'affaire' });
            }
          }
        }
    }
</script>

<style scoped>

</style>
